import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_88zusr2wye: FaireBrandEntity = {
  token: "b_88zusr2wye",
  type: "brand",
  name: "Goldie Charm Bar",
  avatarUrl:
    "https://cdn.faire.com/fastly/66b5e1f82477c67940fc1dd6e94557f612a4a51e517935873c66f78ecdbbc569.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a66c757532762d253697c0538d9140d1554a567477e2c12016c02ee7b50dd18e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/66b5e1f82477c67940fc1dd6e94557f612a4a51e517935873c66f78ecdbbc569.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a66c757532762d253697c0538d9140d1554a567477e2c12016c02ee7b50dd18e.jpeg",
  location: "Raleigh, NC, USA",
  minimumOrderDollars: 207,
  rating: 5,
  reviewCount: 8,
  isTopShop: true,
  isInsider: true,
  description:
    "At Goldie, we believe jewelry should tell a story — and our charm bar lets your customers write their own.\n\nWe make it easy for boutiques to offer a fully customizable charm bar with everything you need:\n→ 18k gold-filled chains\n→ Over 100 bestselling charms\n→ Merchandising kits + refill bundles\n\nWe’ve designed our collection with retailers in mind:\n\t•\tFast-selling, high-margin gold-plated charms\n\t•\tConnector rings pre-attached for instant customization\n\t•\tStylish 18k gold-filled chains in six bestselling styles\n\t•\tFree merchandising support + charm bar setup tips\n\nWhether you’re adding a small charm display or creating a full-scale experience, we make it easy to get started (and even easier to restock).\nWe’re proud to be a Faire Top Shop and to partner with incredible retailers across the country who bring our charms to life.\n\nLet us know if you need help building your dream charm bar — we’re always here to help.",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:08.309Z",
    importedBy: "entity-db-cli",
  },
};
